import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import QueryString from 'qs';
import { RootState } from "../../../store/rootReducer";
import { useSelector } from "react-redux";
import useNotification from "../../../hooks/useNotification";
import { ICreateNoticeInfo } from '../../../models/notification.model';
import { useEffect, useState } from "react";
import moment from "moment";
import useUtil from "../../../hooks/useUtil";
import NoticeMultilEditor from "./NoticeMultiEditor";
import Button from "../../Button";
import { IGetTimetables } from "../../../models/campusClasses3.model";
import useAxios from "../../../hooks/useAxios";
import { getTimetables } from "../../../api/campusClasses3.api";
import { createNotification } from "../../../api/notification.api";
import { AxiosError } from "axios";

interface IProps {
    event: any;
    completeSubmit: (isPartial: boolean) => void;
    toSubmit: boolean;
    setToSubmit: (toSubmit: boolean) => void;
    isTutor?: boolean;
    className?: string|undefined;
    setIsLoading: (isLoading: boolean) => void;
    setConfirmText: (confirmText: string) => void;
    setConfirmTitle: (confirmTitle: string) => void;
}

interface ICreateErrorResult {isError : boolean, errorMessage : string}

const getDefaultData = (alarmYN:string) => {
    return {noticeType:undefined, noticeDetailType:undefined, classTimeSeq:undefined, subjectCode:undefined, title:'', content:'', dueDate:moment().format('YYYYMMDD'), alarmYN:alarmYN, sms:false, resvYn:'N', resvDateTime:'', files:[null]};
}

const NoticeMultiCase = ({
    event,
    completeSubmit,
    toSubmit,
    setToSubmit,
    isTutor = false,
    className,
    setIsLoading,
    setConfirmText,
    setConfirmTitle
} : IProps) => {
    const { t } = useTranslation();
    const location = useLocation();
    const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
    const { getCommonCodeLabel } = useUtil();
    const [noticeCnt, setNoticeCnt] = useState<number>(1);
    const [uniqueNo, setUniqueNo] = useState<number>(1);
    const [dataList, setDataList] = useState<Map<number, ICreateNoticeInfo>>(new Map<number, ICreateNoticeInfo>());
    const [eachData, setEachData] = useState<Map<number, ICreateNoticeInfo>>(new Map<number, ICreateNoticeInfo>());
    const [noticeList, setNoticeList] = useState<Map<number, any>>(new Map<number, any>());
    const classCode = String(query.classCode);    
    const { auth } = useSelector((state: RootState) => state.auth);
    const { chosenClass } = useSelector((state: RootState) => state.class);
    const { infoNotification, warningNotification } = useNotification();
    const [isFirstRun, setIsFirstRun] = useState(true);
    const { data: res, isLoading, error, execute } = useAxios<IGetTimetables>();

    //init
    useEffect(() => {
        let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
        tempData.set(1, getDefaultData('Y'));
        
        const tempNoticeList : Map<number, any> = new Map(noticeList.entries());
        tempNoticeList.set(1, <NoticeMultilEditor key={1} uniqueNo={1} event={event} dataList={tempData} setEachData={setEachData} timeTables={undefined} />);

        setDataList(tempData);
        setNoticeList(tempNoticeList);       

        if (chosenClass?.classCode) {
            execute(getTimetables(chosenClass.classCode));            
        }
    }, []);

    //알림장 개별 Component 수정 시 useEffect
    useEffect(() => {
        if (isFirstRun) {
            setIsFirstRun(false);
            return;
        }
        let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>(dataList.entries());
        eachData.forEach((value, key) => {
            tempData.set(key, value);
        })
        setDataList(tempData);
    }, [eachData]);

    //confirm Text 셋팅
    useEffect(() => {
        let tempDataList : Map<number, any> = new Map(dataList.entries());
        let tempConfirmText = '';
        let tempTitleText = '';
        let resvCnt = 0;

        for(const [key] of tempDataList) {
            if('Y' === dataList.get(key)?.resvYn)  {
                resvCnt++;
                tempConfirmText += t('class.class.title15') + '(' + key + ') - ' 
                + ((dataList.get(key)?.resvDateTime) ? moment(dataList.get(key)?.resvDateTime).format('YYYY.MM.DD HH:mm') : t('class.notice.label1')) + '\n';
            }
        }

        if(resvCnt > 0) {
            tempConfirmText += '\n' + t('class.notice.message2');
            tempTitleText += t('class.notice.message3');
        } else {
            tempConfirmText = t('campus.setting.text7');
            tempTitleText += t('class.class.title14');
        }

        setConfirmText(tempConfirmText);
        setConfirmTitle(tempTitleText);
    }, [dataList]);

    //알림장 추가
    const addNoticeEditor = () => {
        let tempNoticeCnt = noticeCnt;
        let tempUniqueNo = uniqueNo;

        tempNoticeCnt++;

        if(tempNoticeCnt > 5) {
            infoNotification('알림장은 최대 5개까지 추가 가능합니다.');
            return false;
        }

        tempUniqueNo++;
        let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
        tempData.set(tempUniqueNo, getDefaultData('N'));
        
        const tempNoticeList : Map<number, any> = new Map(noticeList.entries());
        tempNoticeList.set(tempUniqueNo, <NoticeMultilEditor key={tempUniqueNo} event={event} uniqueNo={tempUniqueNo} dataList={tempData} setEachData={setEachData} timeTables={res?.data} />);

        setNoticeCnt(tempNoticeCnt);
        setUniqueNo(tempUniqueNo);
        setNoticeList(tempNoticeList);
    }

    //알림장 삭제
    const delNoticeEditor = (delUniqueNo : number) => {
        if(delUniqueNo === 1) {
            return false;
        }
        let tempNoticeCnt = noticeCnt;
        tempNoticeCnt--;

        setNoticeCnt(tempNoticeCnt);

        let tempDataList : Map<number, any> = new Map(dataList.entries());
        tempDataList.delete(Number(delUniqueNo));
        setDataList(tempDataList);

        let tempNoticeList : Map<number, any> = new Map(noticeList.entries());
        tempNoticeList.delete(Number(delUniqueNo));
        setNoticeList(tempNoticeList);
    }

    //알림장 저장 버튼 클릭 시 useEffect
    useEffect(() => {
        if (toSubmit) {
            (async()=>{
                setToSubmit(false);

                if ((!isTutor && !chosenClass) || !event) return;
                
                let dataCheck : boolean = true;
                let noticeNo : number = 1;
                let tempDataList : Map<number, any> = new Map(dataList.entries());

                //필수 데이터 체크
                for(const [key] of tempDataList) {
                    let tempDataCheck = submitDataCheck(key, noticeNo);
                    noticeNo++;

                    if(!tempDataCheck) {
                        dataCheck = false;
                        break;
                    }
                }

                //서버 호출 실행
                if(dataCheck) {
                    let completeNo : number = 0;
                    let createIdx : number = 0;
                    setIsLoading(true);

                    for(const [key] of tempDataList) {
                        const submitResult : ICreateErrorResult = await handleSubmit(key);
                        createIdx++;

                        if(submitResult.isError) {
                            let errorMessage = 'Data 저장 시 알림장[' + createIdx + ']에서 오류가 발생하였습니다. (' + submitResult.errorMessage + ')';
                            if(completeNo >= 1) {
                                errorMessage += ' 알림장[' + completeNo + '] 까지의 Data는 저장 완료하였습니다.';
                            }
                            warningNotification(errorMessage);
                            break;
                        } else {
                            completeNo++;

                            //저장 완료된 알림장 제거
                            let tempNoticeCnt = noticeCnt;
                            tempNoticeCnt--;

                            setNoticeCnt(tempNoticeCnt);

                            let deleteDataList : Map<number, any> = new Map(dataList.entries());
                            deleteDataList.delete(Number(key));
                            setDataList(deleteDataList);

                            let deleteNoticeList : Map<number, any> = new Map(noticeList.entries());
                            deleteNoticeList.delete(Number(key));
                            setNoticeList(deleteNoticeList);
                            //저장 완료된 알림장 제거
                        }    
                    }

                    setIsLoading(false);
                    completeSubmit(tempDataList.size === completeNo);
                }
            })();
        }
    }, [toSubmit]);

    const submitDataCheck = (createNo:number, noticeNo:number) => {
        let noticeType = dataList.get(createNo)?.noticeType;
        let noticeDetailType = dataList.get(createNo)?.noticeDetailType;
        let subjectCode = dataList.get(createNo)?.subjectCode;
        let title = dataList.get(createNo)?.title;
        let content = dataList.get(createNo)?.content;
        let dueDate = dataList.get(createNo)?.dueDate;
        let resvYn = dataList.get(createNo)?.resvYn;
        let resvDateTime = dataList.get(createNo)?.resvDateTime;

        //1. 등록 dataList 중 subjectCode 중복 있는지 체크
        //2. 서버에 subjectCode 중복 있는지 체크

        if (!noticeType) {
            infoNotification(t('class.class.title15') + noticeNo + ' ' + t('class.notice.message1'));
            return false;
        }
        
        if(noticeType==='HW') {
            if (!subjectCode) {
                infoNotification(t('class.class.title15') + noticeNo + ' ' + t('class.class.message29'));
                return false;
            }
        }
        
        if(noticeType==='AN') {
            if(!noticeDetailType) {
                infoNotification(t('class.class.title15') + noticeNo + ' ' + t('class.class.message29'));
                return false;
            }
        }

        if (!title) {
            infoNotification(t('class.class.title15') + noticeNo + ' ' + t('class.class.message30'));
            return false;
        }
        if (!content) {
            infoNotification(t('class.class.title15') + noticeNo + ' ' + t('class.class.message31'));
            return false;
        }

        if (!dueDate) {
            infoNotification(t('class.class.title15') + noticeNo + ' ' + t('student.student.message16'));
            return false;
        }

        if(!resvYn) {
            infoNotification(t('class.class.title15') + noticeNo + ' ' + t('class.notice.message4'));
            return false;
        } else if(resvYn === 'Y' && !resvDateTime) {
            infoNotification(t('class.class.title15') + noticeNo + ' ' + t('class.notice.message5'));
            return false
        } else if(resvYn === 'Y' && resvDateTime) {
            const now = new Date();
            const tempResvDateTime = new Date(resvDateTime);
            if (tempResvDateTime < now) {
                infoNotification(t('class.class.title15') + noticeNo + ' ' + t('class.notice.message9'));
                return false;
            }
        }
        
        return true;
    }

    const handleSubmit = async (createNo:number) => {
        let noticeType = dataList.get(createNo)?.noticeType;
        let noticeDetailType = dataList.get(createNo)?.noticeDetailType;
        let classTimeSeq = dataList.get(createNo)?.classTimeSeq;
        let subjectCode = dataList.get(createNo)?.subjectCode;
        let title = dataList.get(createNo)?.title;
        let content = dataList.get(createNo)?.content;
        let files = dataList.get(createNo)?.files;
        let dueDate = dataList.get(createNo)?.dueDate;
        let alarmYN = dataList.get(createNo)?.alarmYN;
        let sms = dataList.get(createNo)?.sms;
        let resvYn = dataList.get(createNo)?.resvYn;
        let resvDateTime = dataList.get(createNo)?.resvDateTime;
    
        const formData = new FormData();
        formData.append('noticeType', String(noticeType));
        formData.append('noticeDetailType', (noticeType==='AN')?String(noticeDetailType):''); //분류가 알림이 아닌 경우(숙제) noticeDetailType = ''
        // @ts-ignore
        formData.append('classCode', isTutor ? classCode : chosenClass.classCode);
        formData.append('timetableCode', event.resource.timetableCode);
        formData.append('classTimeSeq', (noticeType==='HW')?String(classTimeSeq):'0');    //분류가 숙제가 아닌 경우(알림) classTimeSeq : 0
        formData.append('subjectCode', (noticeType==='HW')?String(subjectCode):'0');    //분류가 숙제가 아닌 경우(알림) subjectCode : 0
        formData.append('title', String(title));
        formData.append('content', String(content));
        formData.append('alarmYN', String(alarmYN));
        formData.append('sms', String(sms));
        formData.append('dueDate', String(dueDate));
        formData.append('resvYn', String(resvYn));
        if(resvYn === 'Y') {
            formData.append('resvDateTime', String(resvDateTime));
        }
    
        /* 파일 처리 */
        if (files.length > 0) {
            files.forEach((item: any) => {
                if (item !== null) {
                formData.append('files', item);
                }
            });
        }
        
        //submit(formData);
        const createResult : ICreateErrorResult = {isError:false, errorMessage:''};
        await createNotification(formData).catch((error : AxiosError) => {
            createResult.isError = true;
            if(error.response?.data.data) {
                createResult.errorMessage = error.response?.data.data;
            } else {
                createResult.errorMessage = t('common.message.error');
            }
        });
        
        return createResult;
    }

    //알림장 리스트 render
    const getNoticeList = () => {
        let tempList = [];

        for(const [key, value] of noticeList) {
            tempList.push(value);
        }
        
        return (
            <>
                {tempList.map((item, idx) => {
                    let noticeCls = (idx !== 0) ? "comm-bx__between" : "";
                    return(
                        <>
                            <div className={noticeCls}>
                            {(idx !== 0) &&
                                <>
                                    <div>
                                        <h3 className="sub-title">{t('class.class.title15') + ' (' + (idx + 1) + ')'}</h3>
                                    </div>
                                    <div className="comm-btn__area right">
                                        <Button
                                            className="btn-basic gray"
                                            onClick={() => {
                                                delNoticeEditor(item.key);
                                            }}
                                            text={t('common.button.delete')}
                                        />
                                    </div>
                                </>
                            }
                            </div>
                            {item}
                        </>
                    )
                })}
            </>
        )
    }

    let scrollStyle = (noticeCnt > 1) ? {overflow:'scroll', paddingBottom:'2px', height:'550px'} : {overflow:'auto', paddingBottom:'2px', height:'auto'};

    return (
        <>
            <div className="comm-bx__between">
                <div>
                    <h3 className="sub-title">{t('class.class.title15')} (1)</h3>
                </div>
                <div className="comm-btn__area right">
                    <Button
                        className="btn-basic pink-line"
                        onClick={addNoticeEditor}
                        text={t('common.button.add')}
                    />
                </div>
            </div>
            <div className='comm-table__area rowType edit mt-0'>
                <table>
                    <colgroup>
                        <col width="150px" />
                        <col width="200px" />
                        <col width="*" />
                        <col width="*" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th className="text-center">{t('class.class.column89')}</th>
                            <td>
                                {moment(event?.start).format('YYYY.MM.DD')}
                            </td>
                            <th className="text-center">{t('class.class.column87')}</th>
                            <td>
                                {getCommonCodeLabel('PR0006', chosenClass?.eduStepCode)}
                            </td>
                        </tr>
                        <tr>
                            <th className="text-center">{t('class.class.column57')}</th>
                            <td colSpan={3}>
                                {isTutor ? className : chosenClass?.className}
                            </td>
                        </tr>
                        <tr>
                            <th className="text-center">{t('class.class.column93')}</th>
                            <td colSpan={3}>
                            {
                                auth?.korName
                            }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style={scrollStyle}>
            {
                getNoticeList()
            }
            </div>

        </>
    )

}

export default NoticeMultiCase;